import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  margin-top: 40%;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ModalFooter = styled.div`
  margin-top: 20px;
`;
export const ModalBody = styled.div``;

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

export const SubText = styled.p`
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 12px;
`;
export const CloseButton = styled.div`
  cursor: pointer;
`;

export const HighlightedDate = styled.span`
  font-weight: bold;
  color: #1976d2;
`;

export const CalendarWrapper = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
